var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './leadershipBio.scss';
import parse from 'html-react-parser';
import IconItem from '../../footer/SubFooter/micro/IconItem';
var LeadershipBio = function (_a) {
    var data = _a.data, closeModal = _a.closeModal;
    var isMobile = window.visualViewport.width < 768;
    var socialIcon = data.iconItems;
    var renderFacts = function (funFacts) {
        var factsList = [];
        funFacts.map(function (fact, index) {
            var ele = (_jsxs("p", { children: [_jsx("span", __assign({ className: "leadershipBio-funFacts_label" }, { children: fact.label }), void 0),
                    _jsx("span", __assign({ className: "leadershipBio-funFacts_fact" }, { children: fact.fact }), void 0)] }, index));
            factsList.push(ele);
        });
        return factsList;
    };
    var renderIcons = function (icons) {
        var iconsList = [];
        icons.map(function (iconItem, index) {
            if (iconItem.url !== '' && iconItem.url !== null) {
                var ele = (_jsx("div", __assign({ className: "leadershipBio-socialIcons_icon" }, { children: _jsx(IconItem, { iconItem: iconItem, index: index }, void 0) }), index));
                iconsList.push(ele);
            }
        });
        return iconsList;
    };
    return (_jsxs("div", __assign({ className: "leadershipBio-section" }, { children: [_jsx("div", { className: "leadershipBio-backdrop" }, void 0),
            _jsx("div", __assign({ className: "leadershipBio-modal" }, { children: _jsxs("div", __assign({ className: "flex flex-col md:flex-row" }, { children: [_jsxs("div", __assign({ className: "leadershipBio-rightCol" }, { children: [_jsxs("div", __assign({ className: "relative" }, { children: [_jsx("img", { className: "leadershipBio-image", src: data.hoverStateImgSrc, alt: data.hoverStateImgAlt }, void 0),
                                        data.hoverStateText && (_jsx("div", __assign({ className: "leadershipBio-hoverStateText" }, { children: parse(data.hoverStateText) }), void 0))] }), void 0),
                                !isMobile && data.funFacts && (_jsx("div", __assign({ className: "leadershipBio-funFacts" }, { children: renderFacts(data.funFacts) }), void 0))] }), void 0),
                        isMobile && _jsx("div", { style: { height: '27px', width: '100vw' } }, void 0),
                        _jsxs("div", __assign({ className: "leadershipBio-leftCol" }, { children: [_jsx("div", { className: "leadershipBio-modalClose", onClick: closeModal }, void 0),
                                _jsxs("div", __assign({ className: "leadershipBio-textWrapper" }, { children: [isMobile && data.funFacts && (_jsx("div", __assign({ className: "leadershipBio-funFacts" }, { children: renderFacts(data.funFacts) }), void 0)),
                                        _jsx("p", __assign({ className: "leadershipBio-name" }, { children: data.name }), void 0),
                                        _jsx("p", __assign({ className: "leadershipBio-title" }, { children: data.title }), void 0),
                                        data.bio && (_jsx("div", __assign({ className: "leadershipBio-bio" }, { children: parse(data.bio) }), void 0)),
                                        isMobile && socialIcon && (_jsx("div", __assign({ className: "leadershipBio-socialIcons" }, { children: renderIcons(socialIcon) }), void 0))] }), void 0),
                                !isMobile && socialIcon && (_jsx("div", __assign({ className: "leadershipBio-socialIcons" }, { children: renderIcons(socialIcon) }), void 0))] }), void 0)] }), void 0) }), void 0)] }), void 0));
};
export default LeadershipBio;
